import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mobile-success-dialog',
  templateUrl: './mobile-success-dialog.component.html',
  styleUrls: ['./mobile-success-dialog.component.scss']
})
export class MobileSuccessDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MobileSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Data can be passed if needed in future
  ) {}

  navigateToWhizzimo(): void {
    window.location.href = 'https://whizzimo.com';
    this.dialogRef.close(); // Optionally close dialog after clicking
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
} 